var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legend" },
    [
      _vm._v("\n    图例：     \n    "),
      _vm._l(_vm.phaseConf, function(phase) {
        return [
          _c("div", { staticClass: "bar", class: phase.cssClass }),
          _vm._v("\n        " + _vm._s(phase.text) + "\n    ")
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76be2c05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76be2c05","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/task/TaskSymb.vue
// module id = 4646
// module chunks = 0